import React from 'react';
import {useQuery} from "@apollo/client";
import {GET_ALL_CERTIFICATES} from "../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";

function QueryAllCertificates (props) {
    const {loading, error, data} = useQuery(GET_ALL_CERTIFICATES);
    if (loading) return 'loading...';
    if (error) return `loading error! ${error.message}`;
    let allCertificates = JSON.parse(data ? data.getAllCertificates : '{"ty":"rt"}');
    const allCertificatesArray = Object.keys(allCertificates).map((Year, index) => <div className="CertificateIMGWeb"
                                                                                        key={index}><img alt='alt'
                                                                                                         src={"https://files.profiforex.com/Documents/" + allCertificates[Year]}/>
    </div>);

    return (
        <div>
            {allCertificatesArray}
        </div>
    )
}
export default QueryAllCertificates